import { Field, Formik } from "formik";
import React, { useState, useEffect } from "react";
import { useDeepEffect } from "../../../abstracts";
import {
  FieldInput,
  FieldDropSide,
  FieldInputFormatted,
} from "../../../components";
import { getCountriesList, getStates } from "../../../services";
import {
  FORM_PLACEHOLDERS,
  getFormattedPhone,
  getFormattedZip,
} from "../../../utils";
import WithdrawalRequestBankAccountDetailsFields from "./WithdrawalRequestBankDetails";
const WithdrawalRequestContactInformationFields = (props) => {
  const toggle = () => {
    props.setAdditionalAddress(!props.additionalAddress);
  };
  const { fields, filteredValues } = props;
  const [stateList, setStateList] = useState([]);
  //const [states, setStates] = useState([]);
  const [countries, setCountries] = useState([]);
  // const { response: countries } = useRequest({
  //   method: getCountriesList,
  //   //payload: 1, //TenantId, HardCoding should be removed
  //   defaultResponse: [],
  // });
  useDeepEffect(() => {
    getCountriesList().then((response) => {
      setCountries(response);
    });
  }, [countries]);

  useDeepEffect(() => {
    getStates().then((response) => {
      setStateList(response);
    });
  }, [stateList]);
  return (
    <Formik>
      <div>
        <p className="mt-20 plan-sub-heading">Contact Information</p>
        <Field
          size="md"
          name={fields.primaryEmailAddress}
          label={"Email"}
          type="text"
          autoComplete="off"
          value={filteredValues.primaryEmailAddress}
          // onChange={handleChange}
          disabled={true}
          component={FieldInput}
        />
        <Field
          size="md"
          name={fields.mobilePhoneNumber}
          label={"Phone Number"}
          type="text"
          autoComplete="off"
          value={getFormattedPhone(filteredValues.mobilePhoneNumber)}
          // onChange={handleChange}
          disabled={true}
          component={FieldInputFormatted}
          placeholder={FORM_PLACEHOLDERS.phone}
          maxLength="12"
        />
        <p className="mt-20 plan-sub-heading">Address</p>
        {/* <Field
        size="md"
        name={fields.address}
        label={"Address Name"}
        type="text"
        autoComplete="off"
        value={values[fields.address]}
        onChange={handleChange}
        disabled={isEdit && !isSave}
        component={FieldInput}
      /> */}
        <Field
          size="md"
          name={fields.address1}
          label={"Address 1"}
          type="text"
          autoComplete="off"
          value={filteredValues.address1}
          // onChange={handleChange}
          disabled={true}
          component={FieldInput}
          isRequired
        />
        <Field
          size="md"
          name={fields.address2}
          label={"Address 2"}
          type="text"
          autoComplete="off"
          value={filteredValues.address2}
          // onChange={handleChange}
          disabled={true}
          component={FieldInput}
        />
        <Field
          size="md"
          name={fields.address3}
          label={"Address 3"}
          type="text"
          autoComplete="off"
          value={filteredValues.address3}
          // onChange={handleChange}
          disabled={true}
          component={FieldInput}
        />
        <Field
          size="md"
          isRequired
          name={fields.city}
          label={"City"}
          type="text"
          autoComplete="off"
          value={filteredValues.city}
          // onChange={handleChange}
          disabled={true}
          component={FieldInput}
        />
        <Field
          size="md"
          isRequired
          name={fields.countryId}
          value={filteredValues.countryId}
          label="Country"
          options={
            countries &&
            countries.map((country, index) => ({
              label: country.code,
              value: country.id,
            }))
          }
          // popupContent={
          //   <SearchableList
          //     label="Select Country"
          //     options={
          //       countries &&
          //       countries.map((country, index) => ({
          //         label: country.code,
          //         value: country.id,
          //       }))
          //     }
          //     onSelect={(value, label) => {
          //       setFieldValue(fields.country, label);
          //       setFieldValue(fields.countryId, value);
          //       setFieldValue(fields.countryCode, label);
          //       setFieldValue(fields.zipCode, null);
          //       value == 1 &&
          //         setFieldValue(fields.foreignCountry, null) &&
          //         setFieldValue(fields.foreignState, null);
          //       value == 2 &&
          //         setFieldValue(fields.state, null) &&
          //         setFieldValue(fields.stateId, null);
          //       getStatesList(fields.countryId)
          //         .then((response) => {
          //           setStateList(response);
          //         })
          //         .catch((error) => {
          //           //Handle error
          //         });
          //     }}
          //     value={values[fields.countryId]}
          //     selectedValue={values[fields.countryId]}
          //   />
          // }
          disabled={true}
          component={FieldDropSide}
        />
        {filteredValues.countryId == 1 && (
          <>
            <Field
              size="md"
              isRequired
              name={fields.stateId}
              options={
                stateList &&
                stateList.map((state, index) => ({
                  label: state.stateDescription,
                  value: state.id,
                }))
              }
              value={filteredValues.stateId}
              label="State"
              // popupContent={
              //   <SearchableList
              //     label="Select State"
              //     options={
              //       stateList &&
              //       stateList.map((state, index) => ({
              //         label: state.stateDescription,
              //         value: state.id,
              //       }))
              //     }
              //     onSelect={(value, label) => {
              //       setFieldValue(fields.state, label);
              //       setFieldValue(fields.stateId, value);
              //     }}
              //     selectedValue={values[fields.stateId]}
              //     height="250px"
              //     value={values[fields.stateId]}
              //   />
              // }
              disabled={true}
              component={FieldDropSide}
            />
            <Field
              size="md"
              isRequired
              name={fields.zipCode}
              label={"Zip Code"}
              type="text"
              autoComplete="off"
              // onChange={handleChange}
              disabled={true}
              component={FieldInputFormatted}
              value={getFormattedZip(filteredValues.zipCode)}
              placeholder={FORM_PLACEHOLDERS.zip}
              maxLength="10"
            />
          </>
        )}
        {filteredValues.countryId == 2 && (
          <>
            <Field
              size="md"
              isRequired
              name={fields.foreignCountry}
              label={"Foreign Country"}
              type="text"
              autoComplete="off"
              value={filteredValues.foreignCountry}
              // onChange={handleChange}
              disabled={true}
              component={FieldInput}
            />
            <Field
              size="md"
              isRequired
              name={fields.foreignState}
              label={"Foreign State"}
              type="text"
              autoComplete="off"
              value={filteredValues.foreignState}
              //onChange={handleChange}
              disabled={true}
              component={FieldInput}
            />
            <Field
              size="md"
              isRequired
              name={fields.zipCode}
              label={"Foreign Zip Code"}
              type="text"
              autoComplete="off"
              // onChange={handleChange}
              disabled={true}
              component={FieldInput}
              value={filteredValues.zipCode}
            />
          </>
        )}
        <WithdrawalRequestBankAccountDetailsFields
          {...props}
          fields={fields}
          filteredValues={filteredValues}
          // isEdit={isEdit}
          // isSave={isSave}
        />
      </div>
    </Formik>
  );
};

export default WithdrawalRequestContactInformationFields;
